import Vue from 'vue'
import VueRouter from 'vue-router'
import Calculadora from '../components/Calculadora.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Autocom',
  //   component: Autocom
  // },
   {
     path: '/',
     name: 'Calculadora',
     component: Calculadora
   },
  {
    path: '/Bienvenida',
    name: 'Bienvenida',    component: () => import(/* webpackChunkName: "Bienvenida" */ '../components/Bienvenida.vue')
  },
  {
    path: '/Reserva',
    name: 'Reserva',    component: () => import(/* webpackChunkName: "Reserva" */ '../components/Reserva.vue')
  },
  {
    path: '/Codigo',
    name: 'Codigo',    component: () => import(/* webpackChunkName: "Codigo" */ '../components/Codigo.vue')
  },
  {
    path: '/CodigoVerificacion',
    name: 'CodigoVerificacion',    component: () => import(/* webpackChunkName: "CodigoVerificacion" */ '../components/CodigoVerificacion.vue')
  },
  {
    path: '/Formulario',
    name: 'Formulario',    component: () => import(/* webpackChunkName: "Formulario" */ '../components/Formulario.vue')
  },
  {
    path: '/Financiamiento',
    name: 'Financiamiento',    component: () => import(/* webpackChunkName: "Financiamiento" */ '../components/Financiamiento.vue')
  },
  {
    path: '/Contado',
    name: 'Contado',    component: () => import(/* webpackChunkName: "Contado" */ '../components/Contado.vue')
  },
  {
    path: '/Registro',
    name: 'Registro',    component: () => import(/* webpackChunkName: "Registro" */ '../components/Registro.vue')
  },
  {
    path: '/Ticket',
    name: 'Ticket',    component: () => import(/* webpackChunkName: "Ticket" */ '../components/Ticket.vue')
  },
  {
    path: '/Recover',
    name: 'Recover',    component: () => import(/* webpackChunkName: "Recover" */ '../components/Recover.vue')
  },
  {
    path: '/InformacionPersonal',
    name: 'InformacionPersonal',    component: () => import(/* webpackChunkName: "InformacionPersonal" */ '../components/InformacionPersonal.vue')
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) =>{
  let isAuthenticated = sessionStorage.getItem("loginAct");
  if(to.name !== "Autocom" && to.name !== "Calculadora" && to.name !== "Bienvenida" && to.name !== "Sesion" && to.name !== "Contado" && to.name !== "Descripcion" && to.name !== "Financiamiento" && to.name !== "Recover" && to.name !== "Registro" && to.name !== "Reserva" && !isAuthenticated) next({path: "/Bienvenida"});
  else next();
});

export default router
